export default "__VITE_ASSET__CAD9Ed7L__"